import { render, staticRenderFns } from "./BrowseSections.vue?vue&type=template&id=57cf4cac&scoped=true&"
import script from "./BrowseSections.vue?vue&type=script&lang=js&"
export * from "./BrowseSections.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BrowseSections.vue?vue&type=style&index=0&id=57cf4cac&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57cf4cac",
  "8cf1a8d8"
  
)

export default component.exports